mutation UpdateTranslation($id: ID!, $input: UpdateTranslationInput!) {
  updateTranslation(id: $id, input: $input) {
    id
  }
}
